import styled from '@emotion/styled';

type Props = {
  src: string;
  alt?: string;
  loading?: 'eager' | 'lazy';
};

const handleDragStart: React.DragEventHandler<HTMLImageElement> = (event) => {
  event.preventDefault();
};

export const Image = styled(
  ({alt = '', loading = 'eager', ...restProps}: Props) => (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions -- FireFox workaround
    <img
      alt={alt}
      {...restProps}
      draggable="false"
      // necessary for Firefox
      onDragStart={handleDragStart}
      loading={loading}
      tabIndex={-1}
    />
  )
)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
`;
